import { themeAwardWidgetDecorator } from '../utils'
import { BowtieAlarmsNotificationSettings } from './BowtieAlarmsNotificationSettings'

export const BowtieAlarmsNotificationSettingsWrapper = themeAwardWidgetDecorator(BowtieAlarmsNotificationSettings)
